export default __webpack_public_path__ + "static/media/girl-frame-mobile-hero.de99ee43.jpg";